import React, { Component, ComponentType } from 'react';

interface IWithCollapsible {
    isCollapsibleSeen?: boolean;
}

interface IState {
    isCollapsibleOpen?: boolean;
}

interface IElementRef {
    contains: (target: EventTarget | null) => boolean;
}

export type TWithCollapsible = {
    isCollapsibleOpen?: boolean;
    openCloseCollapsible?: () => void;
    closeCollapsible?: () => void;
};

export function WithCollapsible<T>(WrapperComponent: ComponentType<T>): ComponentType<T> {
    class Wrapper extends Component<any, IState> {
        private dropDownRef: IElementRef | undefined;
        readonly refHandlers = {
            dropDownRef: (ref: any) => (this.dropDownRef = ref),
        };

        constructor(props: IWithCollapsible) {
            super(props);
            const { isCollapsibleSeen } = props;
            this.state = {
                isCollapsibleOpen: isCollapsibleSeen,
            };
        }

        componentDidMount() {
            const { addEventListener } = window;
            addEventListener('mousedown', this.handleClickOutside);
        }

        componentWillUnmount() {
            const { removeEventListener } = window;
            removeEventListener('mousedown', this.handleClickOutside);
        }

        handleClickOutside = (event: MouseEvent) => {
            const { target } = event;
            this.dropDownRef &&
                !this.dropDownRef.contains(target) &&
                this.setState({ ...this.state, isCollapsibleOpen: false });
        };

        asyncCloseCollapsible = async (cb: () => void) => {
            await new Promise(resolve => {
                resolve(cb);
            }).then(() => this.closeCollapsible());
        };

        openCloseCollapsible = () => {
            const { isCollapsibleOpen } = this.state;
            this.setState({ ...this.state, isCollapsibleOpen: !isCollapsibleOpen });
        };

        closeCollapsible = () => this.setState({ ...this.state, isCollapsibleOpen: false });

        openCollapsible = () => this.setState({ ...this.state, isCollapsibleOpen: true });

        render() {
            const { isCollapsibleOpen } = this.state;

            return (
                <WrapperComponent
                    isCollapsibleOpen={isCollapsibleOpen}
                    childRef={this.refHandlers.dropDownRef}
                    openCloseCollapsible={this.openCloseCollapsible}
                    closeCollapsible={this.closeCollapsible}
                    openCollapsible={this.openCollapsible}
                    asyncClose={this.asyncCloseCollapsible}
                    {...(this.props as T)}
                />
            );
        }
    }

    return Wrapper;
}
